import React from 'react';
import { BaseButton, useIsMobile, useT } from '@repo/common';
import HeaderText from './HeaderText';

import { ReactComponent as ProfileIcon } from '@repo/common/assets/icons/16px/icon_16px_profile_outline.svg';
import { ReactComponent as OfficeWorkerIcon } from '@repo/common/assets/icons/16px/icon_16px_office-worker_outline.svg';
import { ReactComponent as BackpackIcon } from '@repo/common/assets/icons/16px/icon_16px_backpack_outline.svg';
import { ReactComponent as SettingIcon } from '@repo/common/assets/icons/16px/icon_16px_setting_outline.svg';
import { ReactComponent as WalletIcon } from '@repo/common/assets/icons/16px/icon_16px_wallet_outline.svg';
import { ReactComponent as ReceiptIcon } from '@repo/common/assets/icons/16px/icon_16px_receipt_outline.svg';
import { ReactComponent as CouponIcon } from '@repo/common/assets/icons/16px/icon_16px_payment-coupon_outline.svg';
import { ReactComponent as MailIcon } from '@repo/common/assets/icons/16px/icon_16px_mail_outline.svg';
import { ReactComponent as PolicyIcon } from '@repo/common/assets/icons/16px/icon_16px_file-draft_outline.svg';
import { ReactComponent as ArrowRightIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-right.svg';

const MENU_LIST = {
  user: [
    { label: 'My Profile', labelKr: '내 프로필', icon: <ProfileIcon /> },
    { label: 'My Apply', labelKr: '내 지원', icon: <OfficeWorkerIcon /> },
    { label: 'Activities', labelKr: '활동', icon: <BackpackIcon /> },
    { label: 'Account setting', labelKr: '계정 설정', icon: <SettingIcon /> },
    { label: 'Payments', labelKr: '결제', icon: <WalletIcon /> },
    { label: 'Coupons', labelKr: '쿠폰', icon: <CouponIcon /> },
  ],
  business: [
    { label: 'Profile', labelKr: '프로필', tab: 'My Profile', icon: <ProfileIcon /> },
    { label: 'Jobs', labelKr: '채용 공고', tab: 'My Apply', icon: <OfficeWorkerIcon /> },
    {
      label: 'Account settings',
      labelKr: '계정 설정',
      tab: 'Account setting',
      icon: <SettingIcon />,
    },
  ],
  admin: [
    { label: 'My Profile', labelKr: '내 프로필', icon: <ProfileIcon /> },
    { label: 'Workshop Management', labelKr: '워크숍 관리', icon: <BackpackIcon /> },
    { label: 'Applications', labelKr: '지원 현황', icon: <OfficeWorkerIcon /> },
    { label: 'User Management', labelKr: '회원 관리', icon: <OfficeWorkerIcon /> },
    { label: 'Payments', labelKr: '결제', icon: <WalletIcon /> },
    { label: 'Refunds & Cancellations', labelKr: '환불 및 취소', icon: <ReceiptIcon />, tab: 'refunds' },
    { label: 'Policies', labelKr: '정책 관리', icon: <PolicyIcon /> },
    { label: 'Policy Notice', labelKr: '약관 개정 안내', icon: <MailIcon /> },
    { label: 'Account setting', labelKr: '계정 설정', icon: <SettingIcon /> },
    { label: 'Coupons', labelKr: '쿠폰', icon: <CouponIcon /> },
  ],
};

const MyProfileSidebar = ({
  activeMenu,
  onMenuClick,
  isAdmin,
  isBusiness,
}) => {
  const menus = isAdmin
    ? MENU_LIST.admin
    : isBusiness
      ? MENU_LIST.business
      : MENU_LIST.user;
  const isMobile = useIsMobile();
  const t = useT();

  return (
    <div className={`flex flex-col w-full items-start gap-2`}>
      {isAdmin && <HeaderText isAdmin={isAdmin} />}
      <div className='w-full tabletH:w-auto'>
        <div className='flex flex-col tabletH:pb-6 items-start gap-2 w-full'>
          {menus.map(({ label, labelKr, tab = label, icon }) => {
            const isActive = activeMenu === tab;

            return (
              <BaseButton
                key={label}
                type='text_basic'
                icon={icon}
                iconAfter={isMobile && <ArrowRightIcon />}
                width={isMobile ? '100%' : isAdmin ? '209px' : '160px'}
                leftalign={true}
                onClick={() => onMenuClick(tab)}
                bgclass={`
                  w-full ${isMobile && 'py-2.5 px-0'}
                  bg-grayscale-gray01 border-none tabletH:hover:bg-grayscale-gray02
                  ${isActive && !isMobile ? 'bg-grayscale-gray02' : ''}
                `}
                textclass={`
                  hover:text-grayscale-gray09
                  ${isActive ? 'text-grayscale-gray09' : ''}
                `}
              >
                {t(label, labelKr)}
              </BaseButton>
            );
          })}
        </div>
        {!isMobile && (
          <div className={`w-full border-t border-grayscale-gray02`} />
        )}
      </div>
      {!isMobile && (
        <BaseButton
          type='text_basic'
          hideIcon
          leftalign
          width={isAdmin ? '' : '160px'}
          bgclass='bg-grayscale-gray01 border-none hover:bg-grayscale-gray02'
          textclass='hover:text-grayscale-gray09'
        >
          {t('Logout', '로그아웃')}
        </BaseButton>
      )}
    </div>
  );
};

export default MyProfileSidebar;
